import { Navigate, Outlet, RouteObject } from 'react-router-dom';
import BankTransfer from '@/pages/Pay/pages/BankTransfer';
import NotFound from '@/pages/NotFound/NotFound';
import Card from '@/pages/Card/Card';
import PayCallback from '@/pages/Pay/pages/PayCallback';
import PayError from '@/pages/Pay/pages/PayError';
import PayConfirmation from '@/pages/Pay/pages/PayConfirmation';
import PaySession from '@/pages/Pay/pages/PaySession';
import Pay from '@/pages/Pay/Pay';
import CardConfirmation from '@/pages/Card/pages/CardConfirmation';
import CardError from '@/pages/Card/pages/CardError';
import { InvoiceProvider } from '@/context/InvoiceContext';
import { PaymentSessionProvider } from '@/context/PaymentSessionContext';
import { RegisterProvider } from '@/context/RegisterContext';
import CardCallback from '@/pages/Card/pages/CardCallback';

export const payCallbackPath = 'paycallback';
export const cardCallbackPath = 'cardcallback';

const routes: RouteObject[] = [
  {
    path: '/',
    children: [
      {
        index: true,
        element: <Navigate to='/pay' replace />
      },
      {
        path: 'pay',
        element: (
          <InvoiceProvider>
            <PaymentSessionProvider>
              <Outlet />
            </PaymentSessionProvider>
          </InvoiceProvider>
        ),
        children: [
          {
            index: true,
            element: <Pay />
          },
          {
            path: 'error',
            element: <PayError />
          },
          {
            path: payCallbackPath,
            element: <PayCallback />
          },
          {
            path: 'confirmation',
            element: <BankTransfer />
          },
          {
            path: 'confirmation/:paymentSessionId',
            element: <PayConfirmation />
          },
          {
            path: ':referenceCode',
            element: <PaySession />
          }
        ]
      },
      {
        path: 'card',
        element: (
          <RegisterProvider>
            <Outlet />
          </RegisterProvider>
        ),
        children: [
          {
            index: true,
            element: <Card />
          },
          {
            path: 'error',
            element: <CardError />
          },
          {
            path: cardCallbackPath,
            element: <CardCallback />
          },
          {
            path: 'confirmation/:paymentSessionId',
            element: <CardConfirmation />
          },
          {
            path: ':registrationCode',
            element: <Card />
          }
        ]
      }
    ]
  },
  { path: '*', element: <NotFound /> }
];

export default routes;
